import React from 'react';
import {BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';

import './App.css';
import NavBarComponent from "./Components/NavBarComponent";
import FooterComponent from "./Components/FooterComponent";

import WelcomeComponent from "./Components/Sections/LandingPage/Welcome/WelcomeComponent";
import HardwareComponent from "./Components/Sections/LandingPage/Hardware/HardwareComponent";
import SoftwareComponent from "./Components/Sections/LandingPage/Software/SoftwareComponent";
import OpenSourceComponent from "./Components/Sections/LandingPage/OpenSource/OpenSourceComponent";
import DocsComponent from "./Components/Sections/LandingPage/Docs/DocsComponent";
import NewsComponent from "./Components/Sections/LandingPage/News/NewsComponent";
import ContactComponent from "./Components/Sections/LandingPage/Contact/ContactComponent";
import AboutUsComponent from "./Components/Sections/LandingPage/AboutUs/AboutUsComponent";

import DocsPage from "./Components/Sections/DocsConttainer/DocsPage"
import {AppSection} from "./Consts";
import AdminPanelComponent from "./Components/Sections/AdminPanelContainer/AdminPanelPage";

function LandingPage() {
    return (
        <>
            <NavBarComponent sectionName={AppSection.Main}/>

            <WelcomeComponent />
            <HardwareComponent />
            <SoftwareComponent />
            <AboutUsComponent />
            <DocsComponent />
            <OpenSourceComponent />
            <NewsComponent />
            <ContactComponent />
        </>
    );
}

// Przenieś hook useLocation do komponentu wewnątrz <Router>
function AppContent() {
    const location = useLocation();
    const isAdminPanel = location.pathname === "/panel_boga";

    return (
        <div className="App">
            <main className="min-h-dvh">
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/docs" element={<DocsPage />} />
                    <Route path="/panel_boga" element={<AdminPanelComponent />} />
                </Routes>
            </main>
            {!isAdminPanel && <FooterComponent />}
        </div>
    );
}

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;
